import StatusScreen from '@/components/StatusScreen';
import TextLink from '@/components/TextLink';
import { MailIcon } from '@/icons';
import { classes } from './utils';

export type ForgotPasswordConfirmationProps = {
  onReturnToLogin: () => void;
};

export default function ForgotPasswordConfirmation({
  onReturnToLogin,
}: ForgotPasswordConfirmationProps) {
  return (
    <StatusScreen
      variant="success"
      icon={<MailIcon size={34} strokeWidth={1.7} />}
      title="Check your email"
      message="If an account exists for that email, we've sent a link to reset your password.">
      <div className={classes.backWrapper}>
        <TextLink onClick={onReturnToLogin}>Back to login</TextLink>
      </div>
    </StatusScreen>
  );
}
